import { render, staticRenderFns } from "./PlayerTraining.vue?vue&type=template&id=b8195da8"
import script from "./PlayerTraining.vue?vue&type=script&lang=js"
export * from "./PlayerTraining.vue?vue&type=script&lang=js"
import style0 from "./PlayerTraining.vue?vue&type=style&index=0&id=b8195da8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports